<form (submit)="reauthThenDeleteUserAccount()">
<h4 mat-dialog-title>Please reauthenticate to perform this action.</h4>
<mat-dialog-content>
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input matInput type="password" name="password" required [(ngModel)]="txtPassword" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button cdkFocusInitial type="submit">
      Submit
    </button>
    <button mat-stroked-button cdkFocusInitial mat-dialog-close>
      Close
    </button>
  </mat-dialog-actions>
</form>